/**
 * 앱으로 보내는 딥링크에 `web_did`(Amplitude web device id)를 싣는다.
 *
 * 앱은 이 값을 받아 `SEND_SYNTHETIC_MERGE` 이벤트를 Amplitude 로 직접 올려, 웹의 비회원
 * device 와 앱의 회원 user 를 한 유저로 통합한다(iOS `AmplitudeService.setSyntheticMergeEvent`,
 * Android `DeepLinkDataSource.amplitudeSyntheticMerge`). 웹이 값을 실어주지 않으면 병합이
 * 일어나지 않아 같은 사람이 두 유저로 집계된다.
 *
 * 규칙은 웹뷰(ably-webview-react `utils/addWebDIDToDeepLink.ts`)와 동일하게 맞춘다.
 * 두 저장소가 같은 앱에 같은 계약으로 값을 넘겨야 한다.
 */
const WEB_DID_QUERY_KEY = 'web_did';

export const addWebDidToDeeplink = ({
  link,
  webDid,
}: {
  link: string;
  /** Amplitude web device id. `getDeviceId()` 결과. */
  webDid: string;
}): string => {
  try {
    const url = new URL(link);

    if (url.searchParams.has(WEB_DID_QUERY_KEY)) return link;

    // `ably://webview?url=…` 처럼 다른 URL 을 값으로 품은 딥링크는 뒤에 붙이면 그 값의
    // 일부로 먹혀 앱이 읽지 못한다. 그런 경우에만 맨 앞으로 보낸다.
    const hasNestedUrlParam =
      url.searchParams.has('url') || url.searchParams.has('encoded_url');

    if (hasNestedUrlParam) {
      const existingParams = Array.from(url.searchParams.entries());
      url.search = new URLSearchParams([
        [WEB_DID_QUERY_KEY, webDid],
        ...existingParams,
      ]).toString();

      return url.toString();
    }

    url.searchParams.append(WEB_DID_QUERY_KEY, webDid);

    return url.toString();
  } catch {
    // 파싱 불가한 링크는 건드리지 않는다(딥링크를 깨뜨리는 것보다 병합을 포기하는 게 낫다).
    return link;
  }
};